<template>
  <div class="token-data-wrapper" :class="{ 'token-data-wrapper-mobile-centered': $device.isMobile, columned }">
    <div class="token-stack">
      <div v-if="mainTokenValue" class="token">
        <div class="pearl-token-image">
          <img
            class="icon-image"
            :src="tokens[tokenData.name.contract as Tokens].toString()"
            width="32"
            loading="lazy"
            alt="Pearl Token Icon"
          />
        </div>

        <div class="text-value">
          <span>{{ mainTokenValue }}</span>
        </div>
      </div>

      <div v-if="tokenData.extraReward && extraTokenValue && tokenData.name.contract !== Tokens.sand" class="token">
        <div class="pearl-token-image">
          <img
            class="icon-image"
            :src="tokenData.extraReward?.media"
            width="32"
            loading="lazy"
            alt="Extra Reward Icon"
          />
        </div>
        <div class="text-value">
          <span>{{ extraTokenValue }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import tokens from '~/public/img/tokens';
import { useMainStore } from '~/stores/mainStore';
import { Tokens, tokensConfig } from '~/utils/constants';

const store = useMainStore();

defineProps<{
  mainTokenValue?: string | number;
  extraTokenValue?: string | number;
  columned?: boolean;
}>();

const tokenData = computed(() => tokensConfig[store.currentToken]);
</script>

<style lang="scss" scoped>
.token-stack {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;
}

.token {
  display: flex;
  align-items: center;
  height: 40px;
}

.token-data-wrapper {
  display: flex;
  flex-direction: column;
  margin-top: 0px;
  margin-bottom: 10px;
}

.token-data-wrapper-mobile-centered {
  align-items: center;
}

.token-data-wrapper-mobile-centered.columned {
  .token-stack {
    flex-direction: column;
    align-items: center;
  }
}

.token-data {
  z-index: 1;
  flex-direction: row;
  align-items: center;
  margin-left: -4px;
  display: flex;
  position: relative;

  @media screen and (max-width: 560px) {
    margin-bottom: 0;
    width: 100%;
  }
}

.pearl-token-image {
  width: 30px;
  margin-right: 4px;
  display: block;

  img {
    display: block;
  }
}

.text-value {
  display: flex;
  color: var(--main-text-color);
  font-size: 30px;
  line-height: 24px;
  line-height: 1;

  @media screen and (max-width: 991px) {
    font-size: 24px;
  }

  @media screen and (max-width: 767px) {
    font-size: 18px;
  }
}
</style>

<style lang="scss">
.el-dialog__title {
  @media screen and (max-width: 767px) {
    font-size: 26px;
  }
}
</style>
